import { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context';
import { Button, Input } from '@/components/common';
import styles from './PlatformLoginPage.module.css';

export function PlatformLoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await login(email, password, undefined, true);
      navigate('/platform');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.logo}>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <path d="M4 6C4 4.89543 4.89543 4 6 4H18L26 12V26C26 27.1046 25.1046 28 24 28H6C4.89543 28 4 27.1046 4 26V6Z" fill="currentColor"/>
              <path d="M18 4V12H26" fill="currentColor" opacity="0.5"/>
            </svg>
          </div>
          <h1 className={styles.title}>System Administration</h1>
          <p className={styles.subtitle}>OHCS Document Management Platform</p>
        </div>

        <form className={styles.form} onSubmit={handleSubmit}>
          {error && <div className={styles.error}>{error}</div>}

          <Input
            label="Email Address"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@ohcs.gov.gh"
            required
          />

          <Input
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
          />

          <Button
            type="submit"
            className={styles.submitButton}
            isLoading={isLoading}
          >
            Sign In
          </Button>
        </form>

        <div className={styles.footer}>
          <p>Platform Administration Access Only</p>
        </div>
      </div>
    </div>
  );
}
